import { z } from 'zod';

export const schemaConsorsBic = z
    .string()
    .min(8)
    .max(11)
    .regex(/^[a-zA-Z]{6}[0-9a-zA-Z -]+$/, 'Invalid characters');
